// extracted by mini-css-extract-plugin
export var childrenContainer = "_4m-0";
export var virtualScrollArea = "_4m-1";